import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=0a9dfc1a&"
import script from "./CustomDialog.vue?vue&type=script&lang=js&"
export * from "./CustomDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomDialog.vue?vue&type=style&index=0&id=0a9dfc1a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports